import React, { useState } from 'react';
import { Dimmer, Loader, Button, Dropdown, Input, Form } from 'semantic-ui-react';
import ReactQuill from 'react-quill';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css';

const MenuItemForm = ({ menuItem, saveHandler, cancelHandler }) => {
    const { category, text, alexaReadableCollection, dateString } = menuItem;
    const [categoryInput, setCategoryInput] = useState(category);
    const [textInput, setTextInput] = useState(text || '');
    const [alexaReadableCollectionInput, setAlexaReadableCollection] = useState<any>(alexaReadableCollection || []);
    const [dateStringInput, setDateStringInput] = useState(new Date(dateString));
    const [loading, setLoading] = useState(false);

    const menuTypes = [
        {
            key: 'breakfast',
            text: 'Breakfast',
            value: 'breakfast',
            content: 'Breakfast',
        },
        {
            key: 'lunch',
            text: 'Lunch',
            value: 'lunch',
            content: 'Lunch',
        },
        {
            key: 'dinner',
            text: 'Dinner',
            value: 'dinner',
            content: 'Dinner',
        },
        {
            key: 'snack',
            text: 'Snack',
            value: 'snack',
            content: 'Snack',
        },
        {
            key: 'alternative',
            text: 'Alternative',
            value: 'alternative',
            content: 'Alternative',
        },
    ];
    const saveItem = async () => {
        setLoading(true);
        await saveHandler({
            ...menuItem,
            category: categoryInput,
            text: textInput,
            alexaReadableCollection: alexaReadableCollectionInput,
            alexaReadableString: alexaReadableCollectionInput.map((e) => e.insert).reduce((acc, s) => acc + s, ''),
            dateString: new Date(dateStringInput).toDateString(),
        });
        setTextInput('');
        setAlexaReadableCollection([]);
        setLoading(false);
    };

    return (
        <div className="">
            <div className="create-menu">
                <Dimmer active={loading} inverted>
                    <Loader active={loading} />
                </Dimmer>
                <Form>
                    <ReactQuill
                        value={textInput}
                        placeholder="Dish name..."
                        onChange={(content, delta, source, editor) => {
                            setTextInput(content);
                            setAlexaReadableCollection(editor.getContents().ops || []);
                        }}
                        modules={{
                            toolbar: false,
                            clipboard: {
                                matchVisual: false,
                            },
                        }}
                    />

                    <div className="fields">
                        <DatePicker
                            selected={dateStringInput}
                            onChange={(date) => setDateStringInput(date)}
                            placeholderText="Date"
                            customInput={<Input placeholder="Date" />}
                        />
                        <Dropdown
                            options={menuTypes}
                            selection
                            defaultValue={categoryInput}
                            onChange={(e, data) => {
                                setCategoryInput(data.value);
                            }}
                        ></Dropdown>
                        <Button
                            primary={textInput ? true : false}
                            disabled={
                                !textInput.length || ['<p></p>', '<p><br></p>'].includes(textInput) ? true : false
                            }
                            onClick={saveItem}
                        >
                            Save
                        </Button>
                        {cancelHandler && <Button onClick={cancelHandler}>Cancel</Button>}
                    </div>
                </Form>
            </div>
        </div>
    );
};
export default MenuItemForm;
